export default "__VITE_ASSET__CMyuDr4F__"